import { type NotificationsInitial } from '@/cam-admin/control-panel/ControlPanel';
import { makeSceneLookup, type Scene } from '@/designs-dev/scenes';

// Every state the CAM notifications feed can be in, paired with the props that
// drive it there. Shared by the live state select (when the stage is on the
// Notifications page) and the notifications handover.
export const notificationScenes: Scene<NotificationsInitial>[] = [
  {
    id: 'feed',
    label: 'Feed',
    kind: 'happy',
    repro:
      'Seeded activity across customers, grouped Today / This week / Earlier',
    initial: {},
  },
  {
    id: 'all-read',
    label: 'All caught up',
    kind: 'happy',
    repro: 'Every notification read — the bell badge clears',
    initial: { allRead: true },
  },
  {
    id: 'empty',
    label: 'No activity yet',
    kind: 'empty',
    repro: 'Feed with no items — “Customer updates will show up here.”',
    initial: { empty: true },
  },
];

export const notificationSceneById = makeSceneLookup(notificationScenes);
